<template>
    <div>
        <div class="level">
            <div />
            <div class="buttons">
                <button
                    v-bind:class = "['btn-single-toggle',  isDraggableDisabled ? '' : 'is-active']"
                    v-on:click   = "isDraggableDisabled = !isDraggableDisabled"
                    v-bind:title = "isDraggableDisabled ? 'Ziehen aktivieren' : 'Ziehen blockieren'"
                ><i class="material-icons">lock</i></button>

                <button
                    v-bind:class = "['btn-single-toggle',  isRouteView ? 'is-active' : '']"
                    v-on:click   = "isRouteView = !isRouteView"
                ><i class="material-icons">place</i></button>
            </div>
        </div>


        <accordion
            v-if                 = "day"
            class                = "day has-hidden-arrow is-concept"
            v-bind:class         = "{ 'is-empty': placeholders.length === 0 }"
            v-bind:isCollapsible = "placeholders.length > 0 || !!createNew"
            v-bind:isOpen        = "placeholders.length > 0 || !!createNew || showEmptyRow"
        >
            <template slot="header">
                <header>
                    <span>{{ day.name }}</span>
                    <div class="day-action-buttons">
                        <i class="material-icons icon-spin" v-if="isLoading.initialize || isLoading.deleting">refresh</i>


                        <simple-menu material icon="more_vert" title="Menu">
                            <button v-on:click="create('hotel')"><i class="material-icons">add</i> Hotel</button>
                            <button v-on:click="create('other')"><i class="material-icons">add</i> Zusatzleistung</button>
                            <button v-on:click="create('ferry')"><i class="material-icons">add</i> Fähre</button>
                            <button v-on:click="create('train')"><i class="material-icons">add</i> Zug</button>
                            <button v-on:click="create('airline')"><i class="material-icons">add</i> Flug</button>
                            <button v-on:click="create('route')"><i class="material-icons">add</i> Routenstichpunkt</button>
                            <button v-on:click="create('free')"><i class="material-icons">add</i> Freitext</button>
                        </simple-menu>
                    </div>
                </header>
            </template>

            <template slot="content">
                <template v-if="placeholders.length > 0 || !!createNew">
                    <draggable v-model="placeholders" v-bind:options="{ disabled: isDraggableDisabled }">
                        <template v-for="placeholder in placeholders">
                            <component
                                v-if="editMode === placeholder.placeholderType + '-' + placeholder.id"
                                v-bind:key="placeholder.sort"

                                v-bind:is="placeholder.placeholderType + '-form'"
                                v-bind:placeholder="placeholder"
                                v-bind:isLoading = "isLoading.saving"

                                v-bind:options="loadedOptions"

                                v-on:save="savePlaceholder"
                                v-on:cancel="editMode = ''"
                            />


                            <component
                                v-else
                                v-bind:key="placeholder.sort"

                                class="block--draggable"
                                v-bind:class="{ 'is-selected': isSelected(placeholder) }"

                                v-bind:is="placeholder.placeholderType + '-view'"
                                v-bind:placeholder = "placeholder"
                                v-bind:isRouteView = "isRouteView"
                                isConcept
                                v-bind:showDuration="false"

                                v-on:click.native = "$store.commit('togglePlaceholder', placeholder)"
                            >
                                <simple-menu material icon="more_vert" title="Menu">
                                    <button v-if="placeholder.placeholderType !== 'route'"
                                        v-on:click.stop="openConceptProviderForm({providers: placeholder.providers, placeholder: placeholder, id: placeholder.id})"
                                    ><i class="material-icons">add</i> Leistungsträger auswählen</button>

                                    <button
                                        v-on:click.stop="editPlaceholder(placeholder)"
                                    ><i class="material-icons">mode_edit</i> Bearbeiten</button>

                                    <button
                                        class="btn-delete"
                                        v-on:click.stop="deletePlaceholder({
                                            key: types[placeholder.placeholderType],
                                            id:  placeholder.id
                                        })"
                                    ><i class="material-icons">delete</i> Löschen</button>
                                </simple-menu>

                                <a v-if="crudLink(placeholder)" :href="crudLink(placeholder) ? crudLink(placeholder)  : '#'" target="_blank">
                                    <i class="material-icons">launch</i>
                                </a>
                                <i class="material-icons" v-else>launch</i>
                            </component>

                        </template>

                        <concept-provider-form ref="conceptProviderForm" :options="[]"/>

                        <component
                            v-if = "createNew"

                            slot = "footer"

                            v-bind:is      = "createNew + '-form'"
                            v-bind:isLoading = "isLoading.saving"

                            v-on:save      = "saveNewPlaceholder"
                            v-on:cancel    = "createNew = ''"

                            v-bind:options = "loadedOptions"
                        />
                    </draggable>
                </template>

                <div class="placeholder is-empty" v-if="showEmptyRow">
                    <div>
                        Bitte
                        <simple-menu>
                            <button v-on:click="create('hotel')">Hotel</button>
                            <button v-on:click="create('other')">Zusatzleistung</button>
                            <button v-on:click="create('ferry')">Fähre</button>
                            <button v-on:click="create('train')">Zug</button>
                            <button v-on:click="create('airline')">Flug</button>
                            <button v-on:click="create('route')">Routenstichpunkt</button>
                            <button v-on:click="create('free')">Freitext</button>
                        </simple-menu>
                        drücken um ein neues Tageselement hinzuzufügen
                    </div>
                </div>
            </template>
        </accordion>


        <loading v-else></loading>


        <div class="is-overlay" v-if="createNew || editMode"></div>
    </div>
</template>



<script>
import axios       from 'axios';
import Draggable   from 'vuedraggable';

import Accordion   from '@components/Accordion';
import Loading     from '@components/Loading';
import SimpleMenu  from '@components/SimpleMenu';
import { notifySuccess, notifyError } from '@components/Notification';
import {listOfDays, prepareForBackend} from '@utilities/functions';

import ConceptProviderForm from "@orders/concepts/days/ConceptProviderForm";
import AirlineView from '@orders/placeholders/components/views/Airline';
import FerryView   from '@orders/placeholders/components/views/Ferry';
import TrainView   from '@orders/placeholders/components/views/Train';
import HotelView   from '@orders/placeholders/components/views/Hotel';
import RouteView   from '@orders/placeholders/components/views/RouteDetail';
import OtherView   from '@orders/placeholders/components/views/Other';
import AirlineForm from '@orders/concepts/days/placeholderForms/Airline';
import FreeView   from '@orders/placeholders/components/views/FreeText';
import FerryForm   from '@orders/concepts/days/placeholderForms/Ferry';
import TrainForm   from '@orders/concepts/days/placeholderForms/Train';
import HotelForm   from '@orders/concepts/days/placeholderForms/Hotel';
import RouteForm   from '@orders/concepts/days/placeholderForms/Route';
import OtherForm   from '@orders/concepts/days/placeholderForms/Other';
import FreeForm   from '@orders/concepts/days/placeholderForms/Free';

import store       from './store';


export default {
    props: {
        day: {
            type: Object,
            required: true,
        },
        options: {}
    },

    data: function () {
        return {
            createNew: false,
            editMode: '',

            loadedOptions: {
                serviceTypes: [],
                dayDestinations: [],
                trainLabels: [],
                clientConfig: [],
            },

            types: {
                airline: 'airlinePlaceholders',
                ferry:   'ferryPlaceholders',
                train:   'trainPlaceholders',
                hotel:   'hotelPlaceholders',
                route:   'routeDetails',
                free:    'freeTextItems',
                other:   'otherPlaceholders'
            },

            isRouteView: true,
            isDraggableDisabled: true,


            isLoading: {
                initialize: false,
                saving:     false,
                deleting:   false
            }
        }
    },

    mounted: function () {
        this.$store.commit('updateDay', this.day);
        this.loadedOptions.dayDestinations = this.day.destinations;
        this.loadedOptions.trainLabels = this.options.trainLabels
        this.loadedOptions.clientConfig = this.options.clientConfig
    },


    computed: {
        placeholders: {
            get: function () {
                if (this.day === null) {
                    return [];
                }


                const airlinePlaceholders = this.day.airlinePlaceholders
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'airline',
                        ...placeholder.id && { sort: `airline-${placeholder.id}` }
                    }));

                const ferryPlaceholders = this.day.ferryPlaceholders
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'ferry',
                        ...placeholder.id && { sort: `ferry-${placeholder.id}` }
                    }));
                const trainPlaceholders = this.day.trainPlaceholders
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'train',
                        ...placeholder.id && { sort: `train-${placeholder.id}` }
                    }));

                const hotelPlaceholders = this.day.hotelPlaceholders
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'hotel',
                        ...placeholder.id && { sort: `hotel-${placeholder.id}`}
                    }));

                const routeDetails = this.day.routeDetails
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'route',
                        ...placeholder.id && { sort: `route-${placeholder.id}` }
                    }));

                const freeTextItems = this.day.freeTextItems
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'free',
                        ...placeholder.id && { sort: `free-${placeholder.id}`}
                    }));


                const otherPlaceholders = this.day.otherPlaceholders
                    .map(placeholder => Object.assign({}, placeholder, {
                        placeholderType: 'other',
                        ...placeholder.id && { sort: `other-${placeholder.id}` }
                    }));

                const placeholders = [
                    ...airlinePlaceholders,
                    ...ferryPlaceholders,
                    ...trainPlaceholders,
                    ...hotelPlaceholders,
                    ...otherPlaceholders,
                    ...routeDetails,
                    ...freeTextItems,
                ];

                let sortHelper = this.day.sortHelper;

                const sortablePlaceholders = [...placeholders]
                    .filter(placeholder => sortHelper.includes(placeholder.sort))

                const newPlaceholders = [...placeholders]
                    .filter(placeholder => !sortHelper.includes(placeholder.sort))

                return [...sortablePlaceholders.sort((a,b) => {
                    return sortHelper.indexOf(a.sort) < sortHelper.indexOf(b.sort) ? -1 : 1;
                }), ...newPlaceholders]
            },

            set: function (newDay) {
                const sortHelper = newDay.map(placeholder => placeholder.sort);
                this.day.sortHelper = sortHelper;
                this.updateDay({ sortHelper: sortHelper });
            }
        },
        sortHelper: function () {
            return this.placeholders
                .filter(placeholder => placeholder.sort)
                .map(placeholder => placeholder.sort);
        },


        showEmptyRow: function () {
            return !this.createNew && this.placeholders.length === 0
        },


        placeholdersGroupToUpdate: function () { return this.$store.state.placeholdersGroupToUpdate; }
    },


    methods: {
        create: function (key) {
            this.createNew = key;

            if (key === 'route' || key === 'free') {
                this.isRouteView = true;
            }
        },


        editPlaceholder: function (placeholder) {
            this.editMode = placeholder.placeholderType + '-' + placeholder.id;
        },


        openConceptProviderForm: function (data = {}) {
            this.$refs.conceptProviderForm.open(data);
        },


        updateDay: function (updatedData = null) {
            let data = null;

            if (updatedData) {
                // If we want only a specific property to update
                data = updatedData;

            } else {
                // Update the sorterHelper
                this.day.sortHelper = this.sortHelper;
                data = prepareForBackend(this.day);
            }

            return new Promise((resolve, reject) => {
                axios.put('/api/day_concepts/' + this.day.id, data, {
                    params: {
                        _groups: ['predefined_free_text_item']
                    }
                }).then(response => {
                        resolve(response);

                    }, error => { reject(error); });
            });
        },


        savePlaceholder: function (placeholder) {
            let index   = -1,
                copyDay = JSON.parse(JSON.stringify(this.day));

            // Update placeholder with the new value
            index = copyDay[this.types[placeholder.placeholderType]].findIndex(item => item.id === placeholder.id);
            copyDay[this.types[placeholder.placeholderType]].splice(index, 1, placeholder);

            copyDay = prepareForBackend(copyDay);


            this.updateDay(copyDay)
                .then(reseponse => {
                    this.editMode = false;
                    this.day      = reseponse.data;
                    notifySuccess('Platzhalter aktualisiert!');

                }, error => {
                    notifyError('Der Platzhalter konnte nicht aktualisiert werden! Server Error!');
                    this.editMode = false;
                })
                .then(() => { this.isLoading.saving = false; });
        },


        saveNewPlaceholder(placeholder) {
            let copyDay = JSON.parse(JSON.stringify(this.day));

            // Add the new placeholder
            copyDay[this.types[this.createNew]].push(placeholder);

            copyDay = prepareForBackend(copyDay);

            this.isLoading.saving = true;

            this.updateDay(copyDay)
                .then(reseponse => {
                    this.day = reseponse.data;

                    // Update the helper (TODO - this should be done on the backend when adding the placeholder)
                    this.updateDay().then(() => {
                        this.createNew = false;
                        this.day       = reseponse.data;
                        notifySuccess('Platzhalter aktualisiert!');
                    });

                }, error => {
                    notifyError('Der Platzhalter konnte nicht aktualisiert werden! Server Error!');
                    this.createNew = false;
                })
                .then(() => { this.isLoading.saving = false; });
        },


        deletePlaceholder: function ({ key, id }) {
            if (confirm('Möchten Sie diesen Platzhalter löschen?')) {
                this.isLoading.deleting = true;
                // Remove the placeholder
                this.day[key] = this.day[key].filter(item => item.id !== id);

                this.updateDay()
                    .then(response => {
                        this.day = response.data;
                        notifySuccess('Platzhalter gelöscht!');

                    }, error => { notifyError('Der Platzhalter konnte nicht gelöscht werden! Server Error!'); })
                    .then(() => { this.isLoading.deleting = false; });
            }
        },


        isSelected: function (placeholder) {
            return !!this.$store.state.placeholdersSelected.find(
                item => item.placeholderType === placeholder.placeholderType &&
                        item.id              === placeholder.id
                )
        },

        crudLink: function(placeholder) {
            const type = placeholder.placeholderType

            if (type === 'other' && placeholder.otherServiceType) {
                return `/other_service_types/${placeholder.otherServiceType.id}`
            } else if (type === 'route' && placeholder.predefinedRouteDetail) {
                return `/routes/${placeholder.predefinedRouteDetail.id}`
            } else if (type === 'free' && placeholder.predefinedFreeTextItem) {
                return `/free_texts}`
            }

            return false;
        }
    },

    watch: {
        placeholdersGroupToUpdate: function () {
            // We specifically check for FALSE as we can  set the group to NULL
            if (this.placeholdersGroupToUpdate !== false) {
                let copyDay = JSON.parse(JSON.stringify(this.day));

                // Modify the group in the selected placeholders
                this.$store.state.placeholdersSelected.forEach(placeholder => {
                    const index = copyDay[this.types[placeholder.placeholderType]].findIndex(item => item.id === placeholder.id);

                    if (index !== -1) {
                        copyDay[this.types[placeholder.placeholderType]][index].sortGroup = this.placeholdersGroupToUpdate;
                    }
                });

                copyDay = prepareForBackend(copyDay);

                // Call to server
                this.updateDay(copyDay)
                    .then(response => {
                        this.$set(this, 'day', response.data);
                        notifySuccess('Platzhalter wurden geändert');

                    }, error => { notifyError('Platzhalter konnten nicht geändert werden! Server Error!'); })
                    .then(() => { this.$store.commit('placeholdersGroupToUpdate', false); });
            }
        }
    },


    store: store,


    components: {
        Accordion,
        Draggable,
        Loading,
        SimpleMenu,
        AirlineView, FerryView, HotelView, RouteView, OtherView, FreeView,TrainView,
        AirlineForm, FerryForm, HotelForm, RouteForm, OtherForm, FreeForm, ConceptProviderForm,TrainForm
    },
}
</script>

